import React, { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const linkClass =
    "text-white relative group py-2 px-4 block cursor-pointer transition";

  return (
    <nav className="w-full bg-gray-800 p-4 text-xl shadow-lg sticky top-0 z-50">
      <div className="container mx-auto flex items-center justify-between">
        <h1 className="text-white text-2xl font-bold">My Portfolio</h1>

        {/* Mobile menu icon */}
        <div
          className="lg:hidden text-white text-3xl cursor-pointer"
          onClick={toggleMenu}
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </div>

        {/* MENU ITEMS */}
        <ul
          className={`lg:flex lg:items-center lg:gap-8 
          lg:static lg:bg-transparent lg:w-auto lg:flex-row 
          ${menuOpen ? "flex flex-col items-center gap-4 absolute top-16 left-0 w-full bg-gray-900 py-4" : "hidden"}
        `}
        >
          {/* HOME */}
          <li>
            <a href="#home" onClick={() => setMenuOpen(false)} className={linkClass}>
              Home
              <span className="absolute left-0 -bottom-1 w-0 h-[2px] bg-white group-hover:w-full transition-all duration-300"></span>
            </a>
          </li>

          {/* ABOUT */}
          <li>
            <a href="#about" onClick={() => setMenuOpen(false)} className={linkClass}>
              About
              <span className="absolute left-0 -bottom-1 w-0 h-[2px] bg-white group-hover:w-full transition-all duration-300"></span>
            </a>
          </li>

          {/* SKILLS */}
          <li>
            <a href="#skills" onClick={() => setMenuOpen(false)} className={linkClass}>
              Skills
              <span className="absolute left-0 -bottom-1 w-0 h-[2px] bg-white group-hover:w-full transition-all duration-300"></span>
            </a>
          </li>

          {/* MY WORK */}
          <li>
            <a href="#mywork" onClick={() => setMenuOpen(false)} className={linkClass}>
              My Work
              <span className="absolute left-0 -bottom-1 w-0 h-[2px] bg-white group-hover:w-full transition-all duration-300"></span>
            </a>
          </li>

          {/* CONTACT */}
          <li>
            <a href="#contact" onClick={() => setMenuOpen(false)} className={linkClass}>
              Contact
              <span className="absolute left-0 -bottom-1 w-0 h-[2px] bg-white group-hover:w-full transition-all duration-300"></span>
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
